export default __webpack_public_path__ + "static/media/medlife.87641afb.jpg";